import axios from "axios";
import { API_URL } from "../../api_calls";

export async function getUserVignettes(userId) {
  const response = await axios.get(
    `${API_URL}/users/${encodeURIComponent(userId)}/vignettes`,
    { withCredentials: true }
  );
  return response.data;
}

export async function updateSelectedVignette(userId, selectedVignetteId) {
  const response = await axios.put(
    `${API_URL}/users/${encodeURIComponent(userId)}/vignette`,
    { selectedVignetteId },
    { withCredentials: true }
  );
  return response.data;
}
